import "@/App.css";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Dentists } from "@/components/Dentists";
import { Treatments } from "@/components/Treatments";
import { Visiting } from "@/components/Visiting";
import { Gallery } from "@/components/Gallery";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { FloatingCTA } from "@/components/CTAButtons";

export default function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, wheelMultiplier: 0.95 }}>
      <div className="overflow-x-hidden bg-[#FDFCF8] text-[#1E293B]">
        <Navbar />
        <main className="pb-8 sm:pb-0">
          <Hero />
          <Marquee />
          <About />
          <Dentists />
          <Treatments />
          <Visiting />
          <Gallery />
          <Contact />
        </main>
        <Footer />
        <FloatingCTA />
        <Toaster position="top-center" richColors />
      </div>
    </ReactLenis>
  );
}
